import defaultAvatar from '../assets/png/default-avatar.png'

export default {
    methods: {
        avatarChecker(url) {
            return url || defaultAvatar;
        }
    }
}
